<!-- DeviceStatusGrid.vue -->
<template>
    <v-container>
      <v-row>
        <v-col
          v-for="device in devices"
          :key="device.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card class="mx-auto" max-width="300">
            <v-card-title style="align-content:center; text-align: center;">
              {{ device.name }}
            </v-card-title>
            
            <v-card-text>
              <v-row align="center">
                <v-col cols="auto">
                  <v-icon
                    :color="device.status === 1 ? 'green' : 'red'"
                    size="64px"
                  >
                      {{  device.icon }}
                  </v-icon>
                </v-col>
                
                <!--v-col>
                {{ device.status === 1 ? 'mdi-gate-xnor' : 'mdi-billboard' }}
                  <div :class="device.status === '1' ? 'green--text' : 'red--text'">
                    {{ device.name}}
                  </div>
                  <div class="text-caption grey--text">
                    狀態開始時間: {{ device.lastUpdate }}
                  </div>
                </v-col-->
              </v-row>
              <v-row>
                <v-col style="align-content:center; text-align: center;">
                  <div :class="device.status ===  1  ? 'white--text' : 'red--text'">
                    狀態開始時間: {{ device.lastUpdate }}
                  </div>
                  
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import axios from 'axios';
  
  const apiUrl = window.config.API_URL;

  const intervalId=ref(null);
  const devices = ref([
    /*
    { id: 1, name: 'Server 1', status: 1, lastUpdated: new Date() },
    { id: 2, name: 'Workstation 1', status: 0, lastUpdated: new Date(Date.now() - 3600000) },
    { id: 3, name: 'Router', status: 1, lastUpdated: new Date() },
    { id: 4, name: 'Printer', status: 0, lastUpdated: new Date(Date.now() - 7200000) },
     */
  ])
  
  const formatTime = (timestamp) => {
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(new Date(timestamp))
  }

  const updateStatus= async ()=>{
    const response = await axios.get(`${apiUrl}/device/deviceStatus`);
                console.log('device data',response.data);
                
                devices.value=response.data;
  };
  

  onMounted(()=>{
    updateStatus();
      intervalId.value=setTimeout(updateStatus, 5000);
      
  });
  
  onUnmounted(()=>{
    if (intervalId.value !==null)
    {
      clearTimeout(intervalId.value); 
    }
  });
  </script>
  
  <style scoped>
  /* Optional custom styles */
  .v-card {
    transition: all 0.3s;
  }
  
  .v-card:hover {
    box-shadow: 0 8px 16px rgba(0,0,0,0.2) !important;
  }

.white--text {
  font-size: 20px;
  color: white;
}

.red--text {
  font-size: 20px;
  color: red;
}

</style>

